import { render, staticRenderFns } from "./BusOccupancyBadge.vue?vue&type=template&id=938fe026&"
import script from "./BusOccupancyBadge.vue?vue&type=script&lang=js&"
export * from "./BusOccupancyBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports